package com.wintermar.inspection.feature.domain.usecase.template

import com.wintermar.inspection.core.domain.FlowResult
import com.wintermar.inspection.feature.domain.model.template.TemplateModel
import com.wintermar.inspection.feature.domain.repository.TemplateRepository
import com.wintermar.inspection.util.Constant
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.flow.Flow
import kotlinx.coroutines.flow.flow
import kotlinx.coroutines.flow.flowOn
import kotlinx.coroutines.flow.onEach

interface CollectTemplateUseCase {
    operator fun invoke(
    ): Flow<FlowResult<TemplateModel>>
}

class CollectTemplateUseCaseImpl(
    private val templateRepository: TemplateRepository,
) : CollectTemplateUseCase {
    override fun invoke(): Flow<FlowResult<TemplateModel>> = flow {
        var hasLocalData = false

        // Collect local DB flow and emit its results
        templateRepository
            .getTemplatesFromLocalDb(1, 1)
            .collect { result ->
                emit(result)
                if (result is FlowResult.Success) {
                    val templateModel = result.data
                    if (templateModel != null && templateModel.data.isNotEmpty()) {
                        hasLocalData = true
                    }
                }
            }

        // If local data exists, stop and do not call remote
        if (hasLocalData) return@flow

        templateRepository.getTemplates(
            page = 1,
            pageSize = Constant.ALL_PAGE_SIZE
        ).onEach { result ->
            if (result is FlowResult.Success) {
                result.data?.let { template ->
                    templateRepository.insertTemplates(template.data)
                }
            }
        }.collect { emit(it) }
    }.flowOn(Dispatchers.Default)
}
